import PropTypes from 'prop-types';

import { Announcement, HelpV2Icon, InfoFilledIcon, OverlayTriggerTooltip } from '@utilities';

import { getQuestionCost } from '../../../../../../utilities/helpers';

import styles from './_index.module.scss';

const pluralize = (count) => (count === 1 ? '' : 's');

const GridAnnouncementText = ({ conceptCount, question }) => {
  const costPerConcept = getQuestionCost(question);
  const isSequentialMonadicSubQuestion = typeof conceptCount === 'number';
  let questionCost = costPerConcept;

  if (isSequentialMonadicSubQuestion) {
    questionCost *= conceptCount;
  }

  return (
    <>
      {isSequentialMonadicSubQuestion && conceptCount < 1 ? (
        <strong>
          This will count as {costPerConcept} question{pluralize(costPerConcept)} per concept for
          your survey.
        </strong>
      ) : (
        <>
          <strong>
            This will count as {questionCost} question{pluralize(questionCost)} for your survey.
          </strong>{' '}
          {isSequentialMonadicSubQuestion && (
            <>
              That is {costPerConcept} question{pluralize(costPerConcept)} per concept, across{' '}
              {conceptCount} concept{pluralize(conceptCount)}.{' '}
            </>
          )}
        </>
      )}
      <OverlayTriggerTooltip content="This is to improve the quality of data and the panelist experience; the time and effort required to answer 4 rows in a grid is similar to answering a single longer multi-select or open-ended question.">
        <HelpV2Icon className={styles['grid-announcement-help-icon']} />
      </OverlayTriggerTooltip>
    </>
  );
};

GridAnnouncementText.propTypes = {
  conceptCount: PropTypes.number,
  question: PropTypes.object.isRequired,
};

const GridAnnouncement = ({ conceptCount, question }) => {
  return (
    <Announcement
      className={styles['grid-announcement']}
      icon={<InfoFilledIcon />}
      text={<GridAnnouncementText conceptCount={conceptCount} question={question} />}
      variant="info"
    />
  );
};

GridAnnouncement.propTypes = {
  conceptCount: PropTypes.number,
  question: PropTypes.object.isRequired,
};

export default GridAnnouncement;
